export default "__VITE_ASSET__404d4c51__"